/** Whether the design-preview library should be routed and shipped. */
export const DESIGN_PREVIEWS_ENABLED: boolean = import.meta.env.DEV;

/** The public path prefix the library is served under. */
export const DESIGN_PREVIEW_ASSET_DIR = 'marked-up-letter';
